<section class="container details-cmd" style="margin-bottom: 50px">
  <header class="flexible upper-case">
      hébergement
  </header>

    <div class="divContnet row col-md-12" *ngIf="!addHousingMode && !joinHousingMode">
      <div  class="col-md-3" style=";background-color: #16baff;height: 140px">
      </div>

      <div class="booking-desc col-md-6" >
        <h3 style="text-transform: uppercase;color: #16BAFF">NOM Hebergement</h3>
        <p>
          Nous louons l'enssemble d'un batiment (400 lits) spécialement pour l'occasion.
          Vous pourrez profiter d'appartements confortables et avec une vue a couper le souffle
          au sein de la résidence 3*** "Plein sud". <br> <br>

          LA résidence se trouve au pied des pites et à moins de 2 min du loueur de skis.
        </p>
      </div>

      <div  class="col-md-3" style="display: inline-block;text-align: right;margin-top: auto;margin-bottom: auto;">
        <div style="margin-bottom: 5px">
          <button (click)="moveToAddHousingMode()" class="btn1">je crée un hébergement </button>
        </div>
        <div>
          <button (click)="moveToJoinHousingMode()" class="btn1">je rejoins un hébergement </button>
        </div>
      </div>
    </div>

    <div class="col-md-12" *ngIf="addHousingMode">
        <h3 style="text-transform: uppercase;margin-top: 10px;text-align: center;color: #16BAFF;">créer un Hébergement</h3>
        <div class="col-md-12" style="margin-top: 50px;text-align: -webkit-center">
          <div class="form-group col-md-4" style="text-align: -webkit-center">
            <label for="type" style="text-transform: uppercase">TYPE D'hebergement</label>
            <select class="form-control" name="type" id="type" [(ngModel)]="housingType">

            </select>
          </div>
        </div>
      <div>
        <div style="text-align: center">
          <button class="btn2">poursuivre </button>
        </div>
      </div>
    </div>

  <div class="col-md-12" *ngIf="joinHousingMode">
    <h3 style="text-transform: uppercase;margin-top: 10px;text-align: center;color: #16BAFF;">rejoindre un Hébergement</h3>
    <div class="col-md-12 row" style="margin-top: 50px;text-align: -webkit-center">
      <div class="form-group col-md-4" style="text-align: -webkit-center;margin-left: auto">
        <label for="roomNber" style="text-transform: uppercase">Entrer le numéro de la chambre</label>
        <input type="text" id="roomNber" name="roomNber" class="form-control" [(ngModel)]="roomNber">
      </div>

      <div class="form-group col-md-4" style="text-align: -webkit-center;margin-right: auto">
        <label for="roomcode" style="text-transform: uppercase">entrer le code chambre</label>
        <input type="text" id="roomcode" name="roomcode" class="form-control" [(ngModel)]="roomcode">
      </div>

    </div>
    <div>
      <div style="text-align: center">
        <button class="btn2">poursuivre </button>
      </div>
    </div>
  </div>

</section>
